export { SocoModalModule } from '@app/soco/modal/modal_module';

// DSS Documentation on SocoModalComponent - http://tiny.sc/cgsocomodalcomponent
export { SocoModalComponent } from '@app/soco/modal/soco-modal.component';
// DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
export { SocoModalService, SocoModalServiceOptions, SocoModalServiceShowOptions, SocoModalPleaseWaitData,
   SocoModalType } from '@app/soco/modal/soco-modal.service';
